import { useEffect, useState } from "react";

/**
 * Qiymatni belgilangan kechikish bilan debounce qiladi.
 *
 * Server tomonidagi qidiruvni har harf kiritilganda emas, foydalanuvchi
 * yozishni bir zum to'xtatgandagina yuborish uchun ishlatiladi (masalan
 * rahbar tanlash `Select`i) — aks holda har keystroke alohida so'rov beradi.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delayMs);
		return () => clearTimeout(timer);
	}, [value, delayMs]);

	return debounced;
}
